import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

// Custom confirmation hook that uses toast-style UI
export const useConfirm = () => {
    const [confirmState, setConfirmState] = useState(null);

    const confirm = (message, onConfirm, onCancel) => {
        const toastId = toast(
            (t) => (
                <div className="flex flex-col gap-3">
                    <p className="font-medium">{message}</p>
                    <div className="flex gap-2 justify-end">
                        <button
                            onClick={() => {
                                toast.dismiss(t.id);
                                if (onConfirm) onConfirm();
                            }}
                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm font-medium"
                        >
                            OK
                        </button>
                        <button
                            onClick={() => {
                                toast.dismiss(t.id);
                                if (onCancel) onCancel();
                            }}
                            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 text-sm font-medium"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            ),
            {
                duration: Infinity, // Keep it open until user clicks
                position: 'top-center',
                style: {
                    minWidth: '300px',
                },
            }
        );
    };

    return confirm;
};

// Simpler confirmation function that returns a promise
export const confirmAction = (message) => {
    return new Promise((resolve) => {
        const toastId = toast(
            (t) => (
                <div className="flex flex-col gap-3">
                    <p className="font-medium">{message}</p>
                    <div className="flex gap-2 justify-end">
                        <button
                            onClick={() => {
                                toast.dismiss(t.id);
                                resolve(true);
                            }}
                            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 text-sm font-medium"
                        >
                            OK
                        </button>
                        <button
                            onClick={() => {
                                toast.dismiss(t.id);
                                resolve(false);
                            }}
                            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 text-sm font-medium"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            ),
            {
                duration: Infinity,
                position: 'top-center',
                style: {
                    minWidth: '300px',
                },
            }
        );
    });
};

